import { FiEye } from "react-icons/fi";
import ModalWrapper from "../UI/ModalWrapper";
import { useState } from "react";
import DescriptionBanner from "../DescriptionBanner";
import { Icon } from "../UI/Icon";
import usePatch from "../../Hooks/usePatch";
import API_ENDPOINTS from "../../Config/api";
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from 'react-toastify';
import SearchBar from "../UI/Searchbar";
import Selector from "./../UI/Selector";
import capitalizeFirstLetter from "../../Utils/capitalizeFirstLetter";
import exportToCsv from "../../Utils/exportToCsv"


export default function FornitoriNonAttiviTable({
  data = [],
  setData,
  refreshData
}) {
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState("");

  const filteredData = (data ?? []).filter((item) => {
    const s = search.toLowerCase();
    const matchText = (item.denominazione ?? "").toLowerCase().includes(s);
    const matchStatus = !statusFilter || (item.stato_contatto ?? "").toLowerCase() === statusFilter;
    return matchText && matchStatus;
  });

  const STATUS_OPTIONS = [
    { value: "", label: "Tutti" },
    { value: "da contattare", label: "Da contattare" },
    { value: "contattata", label: "Contattata" },
    { value: "rifiutato", label: "Rifiutata" },
    { value: "contrattualizzata", label: "Contrattualizzata" },
  ];
  const COLUMNS = [
    { header: "Ragione sociale", key: "denominazione" },
    { header: "Partita IVA", key: "partita_iva" },
    { header: "Stato contatto", key: "stato_contatto", format: (v) => (v ? v.toUpperCase() : "") },
    { header: "Email riferimento", key: "email_riferimento" },
    { header: "Email contatto", key: "email_contatto" },
    { header: "Codice fiscale", key: "codice_fiscale" },
    { header: "Telefono", key: "telefono" },
    { header: "Indirizzo", key: "indirizzo" },
    { header: "Dominio web", key: "dominio_web" },
    { header: "Nota", key: "nota" },
  ];

  function handleExporToCsv() {
    exportToCsv(filteredData, {
      columns: COLUMNS,
      delimiter: ";",
      filename: "fornitori_non_attivi",
      excelSepHint: true,
      includeBom: true,
    });
  }


  return (
    <div>
      <div className="mb-4 flex justify-between">
        <SearchBar
          search={search}
          setSearch={setSearch}
          placeholder={null}
        />
        <div className="flex gap-2">
          <Selector
            value={statusFilter}
            icon={<Icon name={'filter'} />}
            onChange={setStatusFilter}
            options={STATUS_OPTIONS}
            placeholder="Tutti gli stati"
            width="w-52"
            rightIcon={true}
            triggerClassName="bg-white text-left text-gray-800 border border-gray-300"
          />
          <button
            className="flex items-center gap-2 bg-white text-gray-800 shadow-md hover:shadow-lg transition-all duration-300 px-3 py-2 rounded-md active:scale-95"
            onClick={handleExporToCsv}
          >
            <Icon name={'download'} />
            Esporta Csv
          </button>
        </div>
      </div>
      <div className="flex flex-col h-[32rem] ">
        <div className="flex-1 min-h-0 overflow-y-auto [scrollbar-gutter:stable] border-[#D1D5DB] border rounded">
          <table className="w-full table-auto text-sm text-slate-200 border-collapse">
            <colgroup>
              <col className="w-[57%]" />
              <col className="w-[10%]" />
              <col className="w-[23%]" />
              <col className="w-[5%]" />
              <col className="w-[5%]" />
            </colgroup>

            <thead className=" text-black text-sm sticky top-0 z-10 bg-[#F3F4F7]">
              <tr>
                <th className="px-3 py-5 text-left font-medium whitespace-nowrap">Ragione sociale</th>
                <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Partita iva</th>
                <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Stato contatto</th>
                <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Dettagli</th>
                <th className="px-3 py-5 text-center font-medium whitespace-nowrap"></th>
              </tr>
            </thead>

            <tbody>
              {filteredData && filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <Row
                    key={item.id}
                    item={item}
                    setData={setData}        // <-- passo setData
                    refreshData={refreshData} // opzionale
                  />
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="text-center py-6 text-slate-400">
                    Nessuna azienda trovata
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

/* ---------------- Row ---------------- */

function Row({
  item,
  setData,
  refreshData
}) {
  const { patchData, loading: patchLoad } = usePatch();

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  // loader solo per la select di stato (per non bloccare tutta la row)
  const [savingStato, setSavingStato] = useState(false);
  const [selectValue, setSelectValue] = useState(""); // 👈 AGGIUNTO: value vuoto per mostrare il placeholder


  const [form, setForm] = useState({

    partita_iva: item.partita_iva ?? "",
    denominazione: item.denominazione ?? "",
    email_riferimento: item.email_riferimento ?? "",
    codice_fiscale: item.codice_fiscale ?? "",
    indirizzo: item.indirizzo ?? "",
    dominio_web: item.dominio_web ?? "",
    telefono: item.telefono ?? "",
    email_contatto: item.email_contatto ?? "",
    nota: item.nota ?? "",
    stato_contatto: item.stato_contatto ?? "",

  });

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // Salvataggio dal modal "Modifica": prima PATCH, poi aggiorno parent via setData
  async function handleSave() {
    try {
      const payload = {};
      for (const k of Object.keys(form)) {
        if ((item[k] ?? "") !== form[k]) {
          payload[k] = form[k] === "" ? null : form[k];
        }
      }

      if (Object.keys(payload).length === 0) {
        setShowEditModal(false);
        return;
      }

      const res = await patchData(API_ENDPOINTS.aggiornaParziale(item.id), payload);

      // Se l'API restituisce l'oggetto aggiornato, uso quello; altrimenti merge locale
      const merged = res && res.id ? res : { ...item, ...payload };

      setData(prev =>
        (Array.isArray(prev) ? prev : []).map((f) => (f.id === item.id ? merged : f))
      );

      toast.success(`Modificato con successo`);
      setShowEditModal(false);
    } catch (err) {
      toast.error(`Errore salvataggio: ${err.message}`);
    }
  }

  // ✅ Cambio stato contatto via POST con placeholder = stato attuale
  const handleChangeStato = async (next) => {
    if (!next) return;
    setSavingStato(true);
    try {
      const res = await patchData(API_ENDPOINTS.aggiornaParziale(item.id), { stato_contatto: next, });

      const updated = res && res.id ? res : { ...item, stato_contatto: next };

      setData((prev) =>
        (Array.isArray(prev) ? prev : []).map((f) => (f.id === item.id ? updated : f))
      );

      toast.success("Stato contatto aggiornato");
      setSelectValue(""); // torna al placeholder (che riflette lo stato aggiornato)
    } catch (err) {
      toast.error(`Errore aggiornamento stato: ${err.message}`);
    } finally {
      setSavingStato(false);
    }
  };

  const statusClass =
    item.stato_contatto.toLowerCase() === "contrattualizzata"
      ? "text-blue-800"
      : item.stato_contatto.toLowerCase() === "contattata"
        ? "bg-green-100 text-green-800 border border-green-400"
        :
        item.stato_contatto.toLowerCase() === "da contattare" ?
          "text-yellow-800 border border-yellow-400"
          :
          "text-red-800 bg-red-100 text-red-800 border border-red-400";



  return (
    <>
      <tr className=" text-black text-yello border-white border-b-4 bg-[#E3E3E3]">

        {/* Ragione sociale */}
        <td className="px-3 py-3">
          <p className="font-semibold leading-tight">
            {item.denominazione ?? "--"}
          </p>
        </td>

        {/* Partita IVA */}
        <td className="px-3 py-3 text-center tabular-nums">
          {item.partita_iva ?? "--"}
        </td>

        {/* Stato contatto (placeholder = stato attuale; scelte: contattata/rifiutata) */}
        <td className="px-3 py-3 text-center tabular-nums">
          {
            item.stato_contatto.toLowerCase() === "contrattualizzata" ?
              <p className={`${statusClass} rounded h-full flex items-center justify-center`}>
                {capitalizeFirstLetter(item.stato_contatto)}
              </p>
              :
              <div>
                {patchLoad ?
                  <ClipLoader size={18} />
                  :
                  <Selector
                    value={selectValue} // "" => mostra il placeholder
                    onChange={handleChangeStato}
                    options={[
                      { value: "contattata", label: "Contattata" },
                      { value: "rifiutato", label: "Rifiutata" },
                    ]}
                    placeholder={capitalizeFirstLetter(item.stato_contatto) || "Seleziona stato"} // stato attuale come placeholder
                    width="w-full"
                    triggerClassName={statusClass}
                    showIcon={false}

                  />}
              </div>
          }
        </td>

        {/* Dettagli */}
        <td className="px-3 py-3 text-center tabular-nums">
          <button
            className="p-2 rounded border hover:bg-gray-300 transition"
            onClick={() => setShowDetailsModal(true)}
          >
            <FiEye className="text-gray-700 w-4 h-4" />
          </button>
        </td>

        {/* Azioni */}
        <td className="px-3 py-3 text-center tabular-nums ">
          <div className="flex items-center gap-2">
            <button onClick={() => setShowEditModal(true)}>
              <Icon name={'edit'} className='active:scale-95 text-gray-500 hover:text-gray-600 duration-300 hover:scale-110 cursor-pointer' />
            </button>
          </div>
        </td>
      </tr >

      {/* Dettagli */}
      <ModalWrapper isOpen={showDetailsModal} onClose={() => setShowDetailsModal(false)
      }>
        <div className="bg-white p-6 rounded">
          <DescriptionBanner title="Dettaglio fornitore" description={form.denominazione || item.denominazione} />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-6  text-sm">
            <div className="w-44">
              <label className="block text-sm text-gray-600 mb-1 font-semibold">Email di riferimento</label>
              <p>{item.email_riferimento ?? '-'}</p>
            </div>

            <div className="w-44">
              <label className="block text-sm text-gray-600 mb-1 font-semibold">Email contatto</label>
              <p>{item.email_contatto ?? '-'}</p>
            </div>

            <div className="w-44">
              <label className="block text-sm text-gray-600 mb-1 font-semibold">Codice fiscale</label>
              <p>{item.codice_fiscale ?? '-'}</p>
            </div>

            <div className="w-44">
              <label className="block text-sm text-gray-600 mb-1 font-semibold">Telefono</label>
              <p>{item.telefono ?? '-'}</p>
            </div>

            <div className="w-44">
              <label className="block text-sm text-gray-600 mb-1 font-semibold">Indirizzo</label>
              <p>{item.indirizzo ?? '-'}</p>
            </div>

            <div className="w-44">
              <label className="block text-sm text-gray-600 mb-1 font-semibold">Dominio web</label>
              <p>{item.dominio_web ?? '-'}</p>
            </div>

            <div className="md:col-span-3">
              <label className="block text-sm text-gray-600 mb-1  font-semibold">Nota</label>
              <div className="w-full border rounded px-3 py-2 min-h-[84px]">
                <p>{item.nota}</p>
              </div>
            </div>
          </div>

          <div className="mt-6 flex justify-end">
            <button
              onClick={() => setShowDetailsModal(false)}
              disabled={patchLoad}
              className="bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded"
            >
              Chiudi
            </button>
          </div>
        </div>
      </ModalWrapper >

      {/* Modifica */}
      < ModalWrapper isOpen={showEditModal} onClose={() => !patchLoad && setShowEditModal(false)}>
        <div className="bg-white p-6 rounded w-[600px]">
          <DescriptionBanner title="Aggiungi nota" description={form.denominazione || item.denominazione} />

          <div className="mt-6 text-sm">
            <div>
              <label className="block text-sm text-gray-600 mb-1">Nota</label>
              <textarea
                name="nota"
                value={form.nota ?? ""}
                onChange={onChange}
                className="w-full border rounded px-3 py-2 min-h-[84px]"
                placeholder="Note opzionali"
              />
            </div>
          </div>

          <div className="mt-6 flex justify-between">
            <button
              onClick={() => setShowEditModal(false)}
              disabled={patchLoad}
              className="bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded"
            >
              Annulla
            </button>
            <button
              onClick={handleSave}
              disabled={patchLoad}
              className={`px-4 py-2 rounded text-white flex items-center justify-center gap-2
                ${patchLoad ? "bg-blue-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`}
              style={{ width: 112 }}
            >
              {patchLoad ? <ClipLoader size={18} color="#fff" /> : "Salva"}
            </button>
          </div>
        </div>
      </ModalWrapper >
    </>
  );
}
